import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { KeyCodes_instancevfnkc2xsbiba as KeyCodes_instance } from '../../models/KeyCode.commonHtml.mjs';
import { RView1jxdnn5qf89cm as RView } from '../RView.commonHtml.mjs';
import { FutureElement3o36ukl4wk2br as FutureElement } from '../RView.commonHtml.js.mjs';
import { ClickableSemantic_getInstance2dwzbc0ganf8f as ClickableSemantic_getInstance } from '../../models/Theme.mjs';
import { vpropka48um9uweps as vprop } from './helpers.commonHtml.mjs';
import { Companion_instance15pczmasjuxgh as Companion_instance } from './ContainingView.commonHtml.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ToggleButton$lambda(it) {
  if (!(it instanceof KeyboardEvent))
    THROW_CCE();
  if (it.code === KeyCodes_instance.hax() || it.code === KeyCodes_instance.iax()) {
    it.preventDefault();
  }
  return Unit_instance;
}
function ToggleButton$checked$lambda($this$vprop) {
  // Inline function 'com.lightningkite.kiteui.views.checked' call
  var tmp = $this$vprop.bb4_1.kb7_1.checked;
  return ((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true;
}
function ToggleButton$checked$lambda_0($this$vprop, value) {
  // Inline function 'com.lightningkite.kiteui.views.checked' call
  $this$vprop.bb4_1.kb7_1.checked = value;
  return Unit_instance;
}
var ToggleButtonClass;
function ToggleButton() {
  if (ToggleButtonClass === VOID) {
    class $ extends RView() {
      constructor(context) {
        super(context);
        var tmp = this;
        // Inline function 'kotlin.apply' call
        var this_0 = new (FutureElement())();
        this.lba(this.qb6_1.abf(ClickableSemantic_getInstance()));
        this_0.zb3_1 = 'input';
        var tmp0 = this_0.bb4_1;
        // Inline function 'com.lightningkite.kiteui.views.type' call
        var value = 'checkbox';
        tmp0.kb7_1.type = value;
        this_0.jb4_1.v('checkResponsive');
        this_0.jb4_1.v('kui');
        // Inline function 'com.lightningkite.kiteui.views.hidden' call
        this_0.bb4_1.kb7_1.hidden = true;
        // Inline function 'com.lightningkite.kiteui.views.display' call
        this_0.db4_1.hb7_1.display = 'none';
        tmp.ocq_1 = this_0;
        this.vb5_1.zb3_1 = 'label';
        this.vb5_1.jb4_1.v('kiteui-stack');
        this.vb5_1.jb4_1.v('checkResponsive');
        this.vb5_1.jb4_1.v('clickable');
        // Inline function 'com.lightningkite.kiteui.views.tabIndex' call
        this.vb5_1.bb4_1.kb7_1.tabIndex = 0;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_1 = this.vb5_1;
        var tmp0_safe_receiver = this_1.xb3_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp0_safe_receiver.addEventListener('keydown', ToggleButton$lambda);
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          // Inline function 'kotlin.run' call
          var tmp_1 = this_1.gb4_1['on' + 'keydown'];
          var old = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
          var tmp_2 = 'on' + 'keydown';
          this_1.gb4_1[tmp_2] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.hax() || it.code === KeyCodes_instance.iax()) {
              it.preventDefault();
            }
            return Unit_instance;
          };
        }
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_2 = this.vb5_1;
        var tmp0_safe_receiver_0 = this_2.xb3_1;
        var tmp_3;
        if (tmp0_safe_receiver_0 == null) {
          tmp_3 = null;
        } else {
          tmp0_safe_receiver_0.addEventListener('keyup', (it) => {
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.hax() || it.code === KeyCodes_instance.iax()) {
              this.ocq_1.cc9();
              it.preventDefault();
            }
            return Unit_instance;
          });
          tmp_3 = Unit_instance;
        }
        if (tmp_3 == null) {
          // Inline function 'kotlin.run' call
          var tmp_4 = this_2.gb4_1['on' + 'keyup'];
          var old_0 = (!(tmp_4 == null) ? typeof tmp_4 === 'function' : false) ? tmp_4 : null;
          var tmp_5 = 'on' + 'keyup';
          this_2.gb4_1[tmp_5] = (it) => {
            var tmp0_safe_receiver = old_0;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.hax() || it.code === KeyCodes_instance.iax()) {
              this.ocq_1.cc9();
              it.preventDefault();
            }
            return Unit_instance;
          };
        }
        this.vb5_1.bbu(this.ocq_1);
        var tmp_6 = this;
        var tmp_7 = ToggleButton$checked$lambda;
        tmp_6.pcq_1 = vprop(this.ocq_1, 'input', tmp_7, ToggleButton$checked$lambda_0);
        this.pcq_1.vah(() => {
          if (this.pcq_1.f2())
            this.vb5_1.jb4_1.v('checked');
          else
            this.vb5_1.jb4_1.w3('checked');
          return Unit_instance;
        });
      }
      wb9(index, view) {
        super.wb9(index, view);
        Companion_instance.nbg(this, index, view);
      }
    }
    initMetadataForClass($, 'ToggleButton');
    ToggleButtonClass = $;
  }
  return ToggleButtonClass;
}
//region block: exports
export {
  ToggleButton as ToggleButton22qnd3p3jsqqx,
};
//endregion

//# sourceMappingURL=ToggleButton.commonHtml.mjs.map
